import { Injectable } from '@angular/core';
import { Quote, QuoteDetail, StockLines } from '../models/quote.model';
import { Observable, BehaviorSubject } from 'rxjs';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError } from 'rxjs/operators';
import { AuthService } from "./auth.service";


@Injectable()
export class QuoteService {

  base_url: string = 'api/Quote';
  startCreateDate: string;
  endCreateDate: string;
  accountCode: string;
  quote: Quote = {} as Quote;

  pageNo: number = 1;

  private watchSearchSubject = new BehaviorSubject<string>('');
  currentWatch = this.watchSearchSubject.asObservable();

  private watchQuoteDetailSubject = new BehaviorSubject<Quote>(this.quote);
  currentQuoteDetailWatch = this.watchQuoteDetailSubject.asObservable();

  //public quoteList$ = new BehaviorSubject<Quote[]>([]);

  public priceList$ = new BehaviorSubject<Quote[]>([]);

  public stocklines$ = new BehaviorSubject<StockLines[]>([]);

  constructor(private http: HttpClient,
    private authService: AuthService
  ) { }

  monitorSearchKeyWordChange(searchKeyWord: string): void {
    this.watchSearchSubject.next(searchKeyWord);
  }

  monitorOrderDetaiChange(quote: Quote): void {
    this.watchQuoteDetailSubject.next(quote);
  }

  // get_quote_list(startCreateDate: string, endCreateDate: string, accountCode: string) {
  //   return this.http.get(this.base_url + "/GetQuoteList").pipe(catchError(this.authService.handleError));
  // }

  getQuoteList(reusableOnly = false): Observable<Quote[]> {
    return this.http.get<Quote[]>(this.base_url + '/GetQuoteList?reusableOnly=' + reusableOnly)
      .pipe(catchError(this.authService.handleError));
  }

  getQuoteDetails(quoteId: string, version: string): Observable<QuoteDetail> {
    return this.http.get<QuoteDetail>(this.base_url + '/GetQuoteDetails?quoteId=' + quoteId + '&version=' + version)
      .pipe(catchError(this.authService.handleError));
  }

  downloadQuote(quoteId: string, version: string): Observable<any> {
    return this.http.get(this.base_url + '/DownloadQuote?quoteId=' + quoteId + '&version=' + version)
      .pipe(catchError(this.authService.handleError));
  }
}
